import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PaymentMethod, PaymentProcessor } from 'models/ChargeIntent'
import { PaymentDetails, PaymentFinalizationData } from './payment-details-types'

// This will be overridden when the store is initialized with actual config
export const initialState: PaymentDetails = {
  type: PaymentMethod.CC,
  method: null,
  processor: PaymentProcessor.STRIPE,
  isAmex: false,
}

export const paymentDetailsSlice = createSlice({
  name: 'paymentDetails',
  initialState,
  reducers: {
    setPaymentType: (state, action: PayloadAction<PaymentMethod>) => {
      state.type = action.payload
    },

    setPaymentMethod: (state, action: PayloadAction<PaymentFinalizationData>) => {
      state.method = action.payload
    },

    setPaymentProcessor: (state, action: PayloadAction<PaymentProcessor>) => {
      state.processor = action.payload
    },

    setIsAmex: (state, action: PayloadAction<boolean>) => {
      state.isAmex = action.payload
    },
  },
})

export const { setPaymentType, setPaymentMethod, setPaymentProcessor, setIsAmex } =
  paymentDetailsSlice.actions

// Export the `paymentDetails` reducer
export default paymentDetailsSlice.reducer
